module.exports = __webpack_public_path__ + "static/media/pic66.5cb0a6ff.jpg";